import { ReactNode, useCallback, useLayoutEffect, useRef, useState } from "react";
import { Router } from "react-router-dom";
import type { BrowserHistory, Update } from "history";

interface HistoryRouterProps {
  history: BrowserHistory;
  basename?: string;
  children?: ReactNode;
}

export function HistoryRouter({ history, basename, children }: HistoryRouterProps) {
  const historyRef = useRef(history);

  const [state, setState] = useState({
    action: historyRef.current.action,
    location: historyRef.current.location,
  });

  const handleHistoryChange = useCallback(({ action, location }: Update) => {
    setState({ action, location });
  }, []);

  useLayoutEffect(() => {
    const unlisten = historyRef.current.listen(handleHistoryChange);
    return unlisten;
  }, [handleHistoryChange]);

  return (
    <Router
      basename={basename}
      location={state.location}
      navigationType={state.action}
      navigator={historyRef.current}
    >
      {children}
    </Router>
  );
}

export default HistoryRouter;
